<script setup lang="ts">
import { ButtonMain } from '@caks/uikit/button'
</script>

<template>
  <div class="not-found">
    <img src="/not-found.jpg" alt="not-found" class="not-found__image" />
    <h1 class="not-found__title">Упс! Страница не найдена или не существует</h1>
    <button-main class="not-found__button" @click="$router.push('/')">На главную</button-main>
  </div>
</template>

<style scoped lang="scss">
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  margin-top: 32px;

  &__image {
    width: 343px;
  }

  &__title {
    @include h1-1;
  }

  &__button {
    width: 289px;
  }
}
</style>
